import { css } from 'styled-components';
import { themeGet } from './themeGet';
import { pxToRem } from '../spacing';
export const interactiveTransition = css `
  transition-property: background, border, color, box-shadow, outline, opacity;
  transition-duration: 0.25s;
  transition-timing-function: ease;

  [data-icon='falcon'] {
    transition-property: inherit;
    transition-duration: inherit;
    transition-timing-function: inherit;
  }
`;
/**
 * Sets the text color to the AI gradient
 * @param shade The shade of the AI color
 */
export const aiTextColor = (shade) => css `
  background-image: ${themeGet(`colors.ai.${shade}`)};
  background-clip: text;
  -webkit-text-fill-color: transparent;

  // for falcon icon
  color: ${themeGet('colors.blue.500')};
`;
/**
 * Sets the background color to the AI gradient
 * @param shade The shade of the AI color
 */
export const aiBackgroundColor = (shade) => css `
  background-image: ${themeGet(`colors.ai.${shade}`)};
`;
/**
 * Sets the border color to the AI gradient using CSS `::before` pseudo element
 * @param shade The shade of the AI color
 *
 * In order to make it work, `<AiBorderStackingOrderGuard />` **must** wrap the component that has the `aiBorderColor` ruleset applied.
 */
export const aiBorderColor = (shade) => css `
  position: relative; // do not set a z-index
  border: ${pxToRem(1)} solid transparent;
  background-clip: padding-box;
  overflow: visible;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: -1;
    margin: -${pxToRem(1)};
    border-radius: inherit;
    background-image: ${themeGet(`colors.ai.${shade}`)};
  }
`;
/**
 * This component **must** wrap a component that has the `aiBorderColor` CSS ruleset applied.
 */
export const aiBorderStackingOrderGuard = css `
  position: relative;
  z-index: 0;
`;
